<div class="upload-credential-modal-wrapper">
  <div class="close-btn">
    <ion-icon (click)="closeModal()" name="close-outline" size="large"></ion-icon>
  </div>
  <app-upload-credential type="modal"></app-upload-credential>
</div>